<template lang="pug">
v-card(class="mx-auto" max-width="auto")
  a(href="" :id="`id_${cadastralBase.codigo}`" :ref="`exportLink_${cadastralBase.codigo}`" hidden)
  l-map(
    @click="mapClick"
    :zoom="zoom"
    :options="mapOptions"
    ref="myMap"
    :center="center"
    @update:center="centerUpdate"
    @update:zoom="zoomUpdate"
    @ready="lefletMapReady()"
    :style="{height: '250px', width: '100%', cursor: cursorStyle}")
    //- control de las capas del mapa
    l-control-layers(ref="lyControl")
    //- control pantalla completa
    l-control-fullscreen(
      position="topleft"
      :options="fullscreenOptions")
    //- COntrool para cargar imagenes georreferenciadas
    load-geotiff-control(v-if="map !== null")
    //- Control para cargar datos vectoriales
    load-vector-control(v-if="map !== null" :list-layers="vectorLayers")
    //- capas base y superpuestas del mapa
    l-wms-tile-layer(
      v-for="l in cadastralLayers"
      :key="l.name"
      :base-url="l.url"
      :layer-type="l.type"
      :layers="l.layers"
      :transparent="l.transparent"
      format="image/png"
      :name="l.name"
      :visible="l.visible")
    //- Poligono del predio encontrado en la base catastral
    l-geo-json(
      v-if="baseInfo !== null"
      :options-style="styleFunctionEstate"
      ref="estateLayer"
      :geojson="baseInfo.geojson")
  v-card-title {{ cadastralBase.nombre }}
    div(v-if="cadastralBasesSearchResult !== null")
      v-btn(
        v-if="baseInfo.geojson"
        small
        color="green"
        class="ma-2 white--text"
        @click="getKLM")
        | Descargar kml
        v-icon(
          right
          dark) mdi-cloud-download-outline
  //- v-card-subtitle {{ cadastralBase.entidad_base.description }}
  div(class="d-flex flex-row")
    v-list-item
      v-list-item-icon
        v-icon mdi-bank
      v-list-item-subtitle {{ cadastralBase.entidad_base.nombre}}
    v-list-item(v-if="cadastralBasesSearchResult !== null")
      v-list-item-icon
        v-icon mdi-earth
      v-list-item-subtitle(v-if="baseInfo.municipio")
        | {{ baseInfo.municipio.nombre}} ({{ baseInfo.municipio.dpto_municipio.nombre }})
      v-list-item-subtitle(v-else) Sin Coincidencia
    v-list-item(v-if="cadastralBasesSearchResult !== null")
      v-list-item-icon
        v-icon(:color="`${baseInfo.area} ? 'green' : 'red'`") mdi-texture-box
      v-list-item-subtitle(v-if="baseInfo.area")
        | {{ baseInfo.area.toFixed(1).replace('.', ',')}} m<sup>2</sup>
      v-list-item-subtitle(v-else) Sin Coincidencia


  //- v-card-actions
    v-btn(
      color="orange lighten-2"
      text)
      | Explore

    v-spacer

    v-btn(
      icon
      @click="show = !show")
      v-icon {{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}

  //- v-expand-transition
    div(v-show="show")
      v-divider

      v-card-text
        | I'm a thing. But, like most politicians, he promised more
</template>

<script>
import tokml from 'tokml';
import { mapGetters, mapState } from 'vuex';
import mapMixin from '@/mixins/mapMixin.js';
import {
  LMap,
  LWMSTileLayer,
  LControlLayers,
  LControl,
  LControlScale,
  LGeoJson,
  LMarker,
  LPolygon,
  LTooltip,
} from "vue2-leaflet";
import LControlFullscreen from 'vue2-leaflet-fullscreen';
import { arkandhaGeoserverUrl } from '@/env';
import LoadGeotiffControl from '@/components/geos/LoadGeotiffControl.vue';
import LoadVectorControl from '@/components/geos/LoadVectorControl.vue';

export default {
  name: 'CadastralValidity',

  components: {
    LMap,
    LControlLayers,
    'l-wms-tile-layer': LWMSTileLayer,
    LControl,
    LControlScale,
    LGeoJson,
    LMarker,
    LPolygon,
    LTooltip,
    LControlFullscreen,
    LoadGeotiffControl,
    LoadVectorControl,
  },

  mixins: [mapMixin],

  props: {
    // propiedad con el nombre de la base Catastral
    cadastralBase: {
      type: Object,
      required: true,
      validator: function (value) {
        if (!value || typeof value.codigo !== 'string'
          || typeof value.nombre !== 'string'
          || typeof value.color !== 'string' 
          || typeof value.entidad_base !== 'object') {
          return false; // La validación base falló
        }
        if (!value.entidad_base || typeof value.entidad_base.nombre !== 'string'
          || typeof value.entidad_base.descripcion !== 'string'
          || typeof value.entidad_base.descentralizado !== 'boolean') {
          return false; // La validación base falló
        }
        return true; // El objeto completo y sus hobbies cumplen la estructura
      },
    },
  },

  emits: [],

  data() {
    return {
      show: false,
      // estado con el estilo del cursor
      cursorStyle: 'grab',
    };
  },

  computed: {
    ...mapGetters('geos', ['getOneCadastral']),
    ...mapState('cadastral', ['cadastralBasesSearchResult']),
    ...mapGetters('cadastral', ['cadastralBaseInfo']),
    cadastralLayers() {
      return this.getOneCadastral(this.cadastralBase.codigo);
    },
    // preopiedad calculada con los datos de la coincidencia
    baseInfo() {
      if (this.cadastralBasesSearchResult === null) return null;
      return this.cadastralBaseInfo(this.cadastralBase.codigo);
    },
    // propieda computada para estilos de los predios de gestion inmobiliaria
    styleFunctionEstate() {
      return () => ({
        weight: 2,
        color: '#F44336',
        opacity: 1,
        fillColor: '#F44336',
        fillOpacity: 0.5
      });
    },
  },

  watch: {
    mapReady:{
      handler(newVal) {
        if (newVal === true) {
          let layerName = this.cadastralBase.nombre;
          const filterLayer = this.layerControl._layers.filter((x) => x.name === layerName)[0].layer;
          this.map.addLayer(filterLayer);
        }
      },
      immediate: true,
    },
    'baseInfo.geojson': {
      async handler(newValue) {
        if (newValue === null || newValue === undefined) return;
        await setTimeout(() => {}, 200);
        if (this.$refs.estateLayer === undefined) return;
        const layer = this.$refs.estateLayer.mapObject;
        this.map.fitBounds(layer.getBounds());
      }
    }
  },

  mounted() {},

  methods: {
    // metodo para descargar el KML
    getKLM() {
      const data = this.$refs.estateLayer.mapObject.toGeoJSON();
      // agregar los atributos al geojson
      let propertyData = {};
      propertyData.municipio = this.baseInfo.municipio.nombre;
      propertyData.departamento = this.baseInfo.municipio.dpto_municipio.nombre;
      propertyData.base = this.cadastralBase.nombre;
      propertyData.area = this.baseInfo.area;
      propertyData.codigo = this.baseInfo.codigo;
      propertyData.codigo_anterior = this.baseInfo.codigo_ant;

      data.features[0].properties = propertyData;
      var kml = tokml(data);

      var convertedData = 'application/xml;charset=utf-8,' + encodeURIComponent(kml);

      // if you want to use the official MIME type for KML
      // var convertedData = 'application/vnd.google-earth.kml+xml;charset=utf-8,' + 
      // encodeURIComponent(kml);
      const today = new Date();
      let formatDate = today.toISOString().replace('T', '_').replace('Z', '');
      formatDate = formatDate.slice(0, formatDate.length - 4);
      document.getElementById(`id_${this.cadastralBase.codigo}`).setAttribute('href', 'data:' + convertedData); 
      document.getElementById(`id_${this.cadastralBase.codigo}`).setAttribute('download',
        `${this.cadastralBase.nombre}_${this.baseInfo.codigo}_predio_${formatDate}.kml`);
      this.$refs[`exportLink_${this.cadastralBase.codigo}`].click();
    },
    // metodo para mostrar la información de catastro de la capa de predios 
    // metodo para agregar coordena con click en el mapa
    async mapClick(e) {
      this.cursorStyle = 'wait';
      // si no esta habilitado el dibujo consultar el serviscio WMS
      await this.getFeatureInfo(
        e,
        this.cadastralBase.codigo,
        arkandhaGeoserverUrl,
        ['codigo', 'codigo_ant', 'registros_1', 'registros_2']);
      this.cursorStyle = 'grab';
    },
  }
};
</script>

<style scoped>
</style>
